import type { IMTokens } from '@/interface/IMTokens';
import type { MarkedOddsToken } from '@/interface/pollux';

export function formatMTokens(markedToken: MarkedOddsToken): IMTokens {
    return {
        m: markedToken.m,
        b: markedToken.b,
        s: markedToken.s,
    };
}
